import React from 'react';

import { ErrorPage, Error } from '../../pages/not-found/error-page';

interface Props {
  error: string;
  resetErrorBoundary: () => void;
}

export const ErrorFallback: React.FC<Props> = ({ error }) => {
  return (
    <ErrorPage>
      <Error message={error.toString()} />
    </ErrorPage>
  );
};
